import styled from 'styled-components';

export const AlfredTools = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  padding: 12px;
`;

export const LeftTools = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const ToolsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ResearchDropdowns = styled.div`
  display: flex;
  gap: 4px;
`;

export const ResearchDropdownsDivider = styled.div`
  padding-left: 8px;
  border-left: 1px solid var(--border-soft);
`;
